import Image from 'next/image'
import Link from 'next/link'

import Layout from 'components/layout'

// With bullets on right
export function r({ title, image, imageAlt, bullets, slug, children }) {
  return (
    <div className="py-20 bg-yellow-50 md:py-40">
      <Layout>
        <div className="grid gap-12 grid-cols-1 md:grid-cols-3">
          {insideElement({ title, image, imageAlt, bullets, slug, children })}
        </div>
        <div className="block mt-12 text-center md:hidden">
          <Link href={`/services/${slug}`}>
            <a className={`px-8 py-3 text-orange text-sm font-normal  border-2 border-orange uppercase`}>
              En savoir plus
            </a>
          </Link>
        </div>
      </Layout>
    </div>
  )
}

// With bullets on left
export function l({ title, image, imageAlt, bullets, slug, children }) {
  return (
    <div className="py-20 md:py-40">
      <Layout>
        <div className="jit-space-y-reverse flex flex-col-reverse space-y-12 md:grid md:gap-12 md:grid-cols-3 md:space-y-0">
          {insideElement({ title, image, imageAlt, bullets, slug, isLeft: true, children }).reverse()}
        </div>
        <div className="block mt-12 text-center md:hidden">
          <Link href={`/services/${slug}`}>
            <a className={`px-8 py-3 text-orange text-sm font-normal  border-2 border-orange uppercase`}>
              En savoir plus
            </a>
          </Link>
        </div>
      </Layout>
    </div>
  )
}

const insideElement = ({ title, image, imageAlt, bullets, slug, isLeft = false, children }) => [
  <div key="A">
    <h2 className="text-center font-serif text-4xl font-bold md:text-5xl">{title}</h2>
    <div className="mt-6 text-justify leading-snug space-y-4">{children}</div>
  </div>,
  <div className="flex items-center justify-center" key="B">
    <div className="relative">
      <div className="relative z-10 w-60 h-60 rounded-full overflow-hidden">
        <Image layout="fill" src={image} alt={imageAlt} className="absolute z-10 object-cover" />
        <div className="z-0 w-full h-full bg-orange-200 object-cover"></div>
      </div>
      <div
        className={`${
          isLeft ? 'rounded-l-full -left-6' : 'rounded-r-full -right-6'
        } w-[9rem] h-[18rem] absolute  -top-6 bg-orange-200 `}></div>
      <div aria-hidden="true" className="left-[calc(50%-1.5rem)] top-[-8.5rem] absolute z-10 hidden md:block">
        <Link href={`/services/${slug}`}>
          <a
            className={`${
              isLeft ? ' bg-backgroundLight' : 'bg-yellow-50'
            } inline-flex items-center justify-center w-12 h-12 text-orange border-2 border-orange rounded-full`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 34 34"
              className="w-8 h-8"
              stroke="currentColor">
              <path strokeWidth={2} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
            </svg>
          </a>
        </Link>
      </div>
      <div
        aria-hidden="true"
        className="h-[30rem] absolute left-1/2 top-1/2 hidden w-0 border-r-2 border-orange md:block"
        style={{ transform: 'translate(0, -50%)' }}></div>
      <div className="bottom-[-8.5rem] absolute left-0 hidden w-full text-center md:block">
        <Link href={`/services/${slug}`}>
          <a
            className={`${
              isLeft ? ' bg-backgroundLight' : 'bg-yellow-50'
            } px-8 py-3 text-orange text-sm font-normal  border-2 border-orange uppercase`}>
            En savoir plus
          </a>
        </Link>
      </div>
    </div>
  </div>,
  <div className="my-auto" key="C">
    <div className="grid gap-4" style={{ gridTemplateRows: `repeat(${bullets.length}, minmax(1, 1fr))` }}>
      {bullets.map((thisBullet) => (
        <Link key={thisBullet.id} href={`/services/${slug}#${thisBullet.id}`}>
          <a>
            <div className={`${isLeft ? 'flex-row-reverse' : 'flex-row'} flex items-center`}>
              <div
                className={`${
                  isLeft ? 'text-right' : 'text-left'
                } flex-none w-24 text-orange font-serif text-6xl font-extralight`}>
                {thisBullet.id}
              </div>
              <div className={`${isLeft ? 'pl-0 text-right ' : 'pr-0 text-left'}  text-orange font-normal uppercase`}>
                {thisBullet.name}
              </div>
            </div>
          </a>
        </Link>
      ))}
    </div>
  </div>
]
